import { useHistoricQuotesLookupPercent } from "@features/fundamentals/hooks/useHistoricQuotesLookup";
import { HistoricalQuotesBaseChart } from "@components/Chart";

interface Props {
  quoteProvider: string;
  tickerSymbol: string;
}

export const HistoricalQuotesChart = ({
  quoteProvider,
  tickerSymbol,
}: Props) => {
  const { data: historicQuotes, isFetching: isHistoricQuotesLoading } =
    useHistoricQuotesLookupPercent(quoteProvider, tickerSymbol);
  return (
    <HistoricalQuotesBaseChart
      historicQuotes={historicQuotes}
      isFetching={isHistoricQuotesLoading}
    />
  );
};
